// extracted by mini-css-extract-plugin
export default {"container":"Actors_container__HzuEi","emotion":"Actors_emotion__4qt3k"};